﻿//CG: cautare Nominatim izolata - URL-ul configurat in MapSearch (Type=NOMINATIM, Content cu {filter})
export default class NominatimSearch {
    constructor(searchConfig) {
        this.config = searchConfig;
    }

    static isNominatim(searchConfig) {
        return searchConfig != null && searchConfig.Type == 'NOMINATIM' && searchConfig.Url != null && searchConfig.Url.trim() != '';
    }

    //CG: intoarce randuri in formatul QuickSearch; la eroare intoarce [] ca sa nu blocheze celelalte cautari
    search(criteria) {
        let url = this.config.Url.replaceAll('{filter}', encodeURIComponent(criteria.trim()));

        return fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(res => res.ok ? res.json() : [])
            .then(result => Array.isArray(result) ? result.map(x => this._toRow(x)).filter(x => x != null) : [])
            .catch(() => []);
    }

    _toRow(item) {
        let bboxWkt = NominatimSearch.bboxToWkt(item.boundingbox);
        if (bboxWkt == null) {
            return null;
        }

        return {
            IdMapSearch: this.config.Id,
            Name: item.display_name,
            IconClass: this.config.Icon,
            Wkt: bboxWkt,
            Lat: item.lat,
            Lon: item.lon,
            DataSourceName: this.config.Name,
            Type: 'NOMINATIM'
        };
    }

    //CG: boundingbox Nominatim = [south, north, west, east] in EPSG:4326
    static bboxToWkt(bbox) {
        if (!Array.isArray(bbox) || bbox.length !== 4) {
            return null;
        }
        const [south, north, west, east] = bbox.map(Number);
        if ([south, north, west, east].some(Number.isNaN)) {
            return null;
        }
        return `POLYGON((${west} ${south}, ${east} ${south}, ${east} ${north}, ${west} ${north}, ${west} ${south}))`;
    }
}
